import { Container } from "react-bootstrap";
import { Whatsapp as WhatsappIcon, TelephoneFill } from "react-bootstrap-icons";
import "../style/ContactStrip.css";

const WHATSAPP_HREF =
  "https://api.whatsapp.com/send?phone=916363018056&text=Hi%2C%20I%27d%20like%20to%20know%20more%20about%20Bit%20Byte%20Foods%20batter.";

const ContactStrip = () => {
  return (
    <section className="contact-strip">
      <Container className="container-narrow contact-strip__inner">
        <div>
          <h2>Questions? Just Ask.</h2>
          <p>We reply fastest on WhatsApp — retailers and distributors welcome too.</p>
        </div>
        <div className="contact-strip__actions">
          <a href={WHATSAPP_HREF} target="_blank" rel="noreferrer" className="btn-turmeric">
            <WhatsappIcon size={20} /> Chat on WhatsApp
          </a>
          <a href="tel:+916363018056" className="btn-leaf-outline">
            <TelephoneFill size={16} /> Call Us
          </a>
        </div>
      </Container>
    </section>
  );
};

export default ContactStrip;
